import React from "react";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";

import { JsonToArray } from "shared/helpers/JsonHelpers";

//create a function to return a display item, which goes into every table cell,  it should be a title and a value that goes horizontally

function DisplayItem(props) {
  return (
    <div
      style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
    >
      <div style={{ fontWeight: "bold", marginRight: "10px" }}>
        {props.title}:
      </div>
      <div>{props.value}</div>
    </div>
  );
}

// //NOTE: This version of DisplayItem stacks the props.title and props.value vertically
// function DisplayItem(props) {
//   return (
//     <div
//       style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}
//     >
//       <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
//         {props.title}:
//       </div>
//       <div>{props.value}</div>
//     </div>
//   );
// }

//This component takes in a json object and Renders it to a grid layout
// DOcumentation on this layout is here.https://www.telerik.com/kendo-react-ui/components/layout/gridlayout
//Also pass in the number of columns to displaY, If not passed, it defaults to 4 columns

export default function RenderDataToGridLayout(props) {
  //convert the json data to an array of objects

  var { data, columnCount } = props;

  var dataArray = JsonToArray(data);

  //if columns are not specified, then default to 4 columns

  if (!columnCount) columnCount = 4;

  return (
    <div style={{ width: "100%" }}>
      <GridLayout
        rows={[{ height: "auto" }, { height: "auto" }, { height: "auto" }]}
        cols={[{ width: "auto" }, { width: "auto" }, { width: "auto" }]}
        // gap={{ rows: 5, cols: 5 }}
        gap={{ rows: 5, cols: 25 }}
        align={{ horizontal: "stretch", vertical: "stretch" }}
      >
        {
          //ADD A row for every 4 items  and then add a cell of Display Item for every key and value

          dataArray &&
            dataArray.map((item, index) => {
              //there are 4 columns
              let currentrow = Math.floor(index / columnCount) + 1;

              //now calculate the current column index for the item in the currentRow variable, which is the remainder of the index divided by 4
              let currentCol = index % columnCount;

              return (
                <GridLayoutItem row={currentrow} col={currentCol} key={index}>
                  <DisplayItem title={item.key} value={item.value} />
                </GridLayoutItem>
              );
            })
        }
      </GridLayout>
    </div>
  );
}
